module.exports = __webpack_public_path__ + "0eeb976d605ec35fb855c9ee9d3a73f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./js/img/brotman_baty_institute_logo.jpg
// module id = 1340
// module chunks = 0